import { render, staticRenderFns } from "./InsuranceNicheIcon.vue?vue&type=template&id=44df1ac6&scoped=true"
import script from "./InsuranceNicheIcon.vue?vue&type=script&lang=js"
export * from "./InsuranceNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df1ac6",
  null
  
)

export default component.exports